import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-input-codeotp',
  templateUrl: './input-codeotp.component.html',
  styleUrl: './input-codeotp.component.scss',
  standalone: false
})
export class InputCodeotpComponent {
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();
  @Input() length = 6; // Default length for OTP code
  /** Vacío por defecto: el fallback traducido vive en el template (ver .html). */
  @Input() placeholder = '';
  @Input() integerOnly = false;
}
